import React from 'react';
import './Highlighter.css'
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import SimpleMenu from "./SimpleMenu";
import {Container, Row, Col} from 'reactstrap';

export default function HighlighterComponent(data) {
    const categories = data.data;
    const [chosenCategories, setChosenCategories] = React.useState(null);

    const updateFilters = (name, chosenCategory) => {
        setChosenCategories(
            {...chosenCategories, [name]: chosenCategory}
        );
    };


    return (
        <div>
            <Card
                className="highlightCard"
                style={{direction: "rtl"}}
            >
                <CardContent style={{width:'100%', padding:'20px 10px'}}>
                    <div style={{display: 'flex', width:'100%'}}>
                        <div className="highlightInnerCard">
                            <h1 className="number">{data.numClasses}</h1>
                            <div className="category">כיתות</div>
                        </div>
                        <div className="highlightInnerCard">
                            <h1 className="number">{data.calcNumberOfCandidates}</h1>
                            <div className="category">מועמדים</div>
                        </div>
                        <div className="highlightInnerCard">
                            <h1 className="number">{data.calcNumberOfReviewers}</h1>
                            <div className="category">מעריכים</div>
                        </div>
                        <div className="grow"/>
                        <Container style={{height:'80%'}}>
                            <Row className="highlightText"  style={{height:'20%'}}>
                                בחר קטגוריות להדגשה:
                            </Row>
                            <Row></Row>
                            <Row
                                className="highlightRow" style={{height:'20%'}}>
                                {categories.map((category, i) => {
                                    return <Col key={i} className="filter"><SimpleMenu changeMenuCallback={updateFilters}
                                                                               className="filterName"
                                                                               data={category}/></Col>
                                })}
                                <Col style={{paddingLeft: "2.5vw"}}>
                                    <Button variant="contained" className="highlightButton" onClick={() => {
                                        data.buttonClickCallback(chosenCategories)
                                    }}>
                                        הדגש
                                    </Button>
                                </Col>
                            </Row>
                            <Row></Row>
                        </Container>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
